import { CommonModule, Location } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  inject,
} from '@angular/core';
import { PureAbility } from '@casl/ability';
import { CustomerType } from 'api';
import { IconPipe } from 'common';

@Component({
  selector: 'ss-stx-shared-customer-header-display',
  templateUrl: './customer-header-display.component.html',
  styleUrls: ['./customer-header-display.component.scss'],
  imports: [CommonModule, IconPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomerHeaderDisplayComponent {
  private location = inject(Location);
  private ability = inject(PureAbility);

  @Input() customerNumber?: number;
  @Input() customerName?: string;
  @Input() customerType!: CustomerType;
  @Input() accountFrozen?: boolean;
  @Output() changeCustomerType = new EventEmitter<void>();

  customerTypeClicked() {
    this.changeCustomerType.emit();
  }
  // only make button clickable if if parent is customer component
  get isCustomerComponentParent(): boolean {
    return (
      this.location.path().split('/')[1] === 'customer' &&
      this.location.path().split('/')[3] !== 'additional-information'
    );
  }
  // only make button clickable if customer type is changeable
  get isChangeableCustomerType(): boolean {
    return (
      this.customerType === 'CONSUMER' || this.customerType === 'ORGANIZATION'
    );
  }

  get makeIconClickable(): boolean {
    return (
      this.ability.can('update', 'customer:type') &&
      this.isCustomerComponentParent &&
      this.isChangeableCustomerType
    );
  }
}
